import { useContext, useEffect, useState } from "react"
import { Box, Typography, Button } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { OneSwitch } from "../../../../../Components/OneSwitch/OneSwitch"
import OneInput from '../../../../../Components/OneInput/OneInput'
import { WebSocketContext } from "../../../../../Providers/WebSocket/WebSocketContext"
import { showNotify } from "../../../../../Utils/Utils"
import { Delete } from '@mui/icons-material'
import RondaSelect from './RondaSelect'
import CopiarPerguntas from './CopiarPerguntas'
import $ from 'jquery'
import 'jquery-mask-plugin'

import { BoxAtivarRonda, BoxHorariosRonda, BtnDeletePergunta, BtnsSalvarCancelar, ContainerConfigRonda, GridBtnsAddAndCopy, GridConfigRonda, GridInputPergunta, GridPaiConfigRonda, GridPerguntas, GridSelecionarEntradas, InputPerguntas, LegendaInputPergunta } from './SxRondaEdit'

const RondaEdit = ({ idCentral, setRenderizarRonda, setOnCloseChanges, rondaEdit, clickEditRonda }) => {
    const { sendWs, addRoute } = useContext(WebSocketContext)
    const [linhas, setLinhas] = useState([])
    const [listaEntrada, setListaEntrada] = useState([])
    const [listaPerguntas, setListaPerguntas] = useState([])
    const [checkedPerguntas, setCheckedPerguntas] = useState([])
    const [openListaPerguntasModal, setListaPerguntasModal] = useState(false)
    const [objEnviado, setObjEnviado] = useState({
        idCentral,
        switchAtivo: true,
        horario_inicial: '',
        horario_final: '',
        tempo_recorrencia: '',
        entrada_escolhida: [],
        perguntas: []
    })

    const [ativoEdit, setAtivoEdit] = useState(true)
    const [entradaMonitoradaEdit, setEntradaMonitoradaEdit] = useState('')
    const [horarioInicialEdit, setHorarioInicialEdit] = useState('')
    const [horarioFinalEdit, setHorarioFinalEdit] = useState('')
    const [perguntasRondaEdit, setPerguntasRondaEdit] = useState('')
    const [tempoRecorrenciaEdit, setTempoRecorrenciaEdit] = useState('')

    useEffect(() => {
        buscaEntradasCondominio()
    }, [])

    useEffect(() => {
        if (clickEditRonda == true && rondaEdit) {
            setAtivoEdit(rondaEdit.ativo)
            setHorarioInicialEdit(rondaEdit.horario_inicial)
            setHorarioFinalEdit(rondaEdit.horario_final)
            setTempoRecorrenciaEdit(rondaEdit.tempo_recorrencia)
            setEntradaMonitoradaEdit(rondaEdit.entrada_monitorada)
            setPerguntasRondaEdit(rondaEdit.perguntas_ronda.split('-|-'))

            setObjEnviado((prevState) => ({
                ...prevState,
                id: rondaEdit.id,
                switchAtivo: rondaEdit.ativo,
                horario_inicial: rondaEdit.horario_inicial,
                horario_final: rondaEdit.horario_final,
                tempo_recorrencia: rondaEdit.tempo_recorrencia
            }))
        }
    }, [rondaEdit])

    useEffect(() => {
        if (clickEditRonda == true) {
            if (Array.isArray(perguntasRondaEdit)) {
                setLinhas(perguntasRondaEdit.map((pergunta, index) => ({ id: index + 1 })))
                setObjEnviado((prevState) => {
                    return {
                        ...prevState,
                        perguntas: perguntasRondaEdit.map(pergunta => {
                        // Aqui você pode processar cada pergunta se necessário
                            return pergunta
                        })
                    }
                })
            }
        }
    }, [perguntasRondaEdit])

    const criarLinha = () => {
        const novaLinha = { id: linhas.length + 1 }
        setLinhas([...linhas, novaLinha])
    }

    const removerLinha = (id) => {
        const novasLinhas = linhas.filter(linha => linha.id !== id)
        setLinhas(novasLinhas)

        setObjEnviado((prevState) => {
            let perguntas = [...prevState.perguntas]
            perguntas = perguntas.slice(0, id - 1)
            return {
                ...prevState,
                perguntas
            }
        })
    }

    const atualizarSwitch = (value) => {
        setObjEnviado((prevState) => ({
            ...prevState,
            switchAtivo: value
        }))
        setAtivoEdit(value)
    }

    const atualizarHorario1 = (value) => {
        setObjEnviado((prevState) => ({
            ...prevState,
            horario_inicial: value
        }))
        setHorarioInicialEdit(value)
    }

    const atualizarHorario2 = (value) => {
        setObjEnviado((prevState) => ({
            ...prevState,
            horario_final: value
        }))
        setHorarioFinalEdit(value)
    }

    const atualizarMinutos = (value) => {
        setObjEnviado((prevState) => ({
            ...prevState,
            tempo_recorrencia: value
        }))
        setTempoRecorrenciaEdit(value)
    }

    $(document).ready(() => {
        $('#switch').click(() => {
            atualizarSwitch($(this).prop('checked'))
        })

        $('#horario1').mask('00:00', { reverse: true }).on('input', () => {
            let value = $('#horario1').val()
            atualizarHorario1(value)
        })

        $('#horario2').mask('00:00', { reverse: true }).on('input', () => {
            let value = $('#horario2').val()
            atualizarHorario2(value)
        })

        $('#minutos').mask('##000', { reverse: true }).on('input', () => {
            atualizarMinutos($(this).val())
        })
    })

    const getListaEntrada = (msg) => {
        const arrayListaEntradas = msg.data.listaEntradas
        const novaListaEntrada = arrayListaEntradas.map((entrada, index) => ({
            descricao: `${entrada.id} - ${entrada.descricao}`,
            id: entrada.id
        }))
        if (novaListaEntrada.length > 0) {
            setListaEntrada(novaListaEntrada)
        }
    }

    const buscaEntradasCondominio = () => {
        const id_central = idCentral
        sendWs("listaEntradas", { id_central })
        addRoute("listaEntradas", getListaEntrada)
    }

    const fecharEditRonda = (msg) => {
        const retorno = msg.data.status
        if (msg.data.status) {
            showNotify("success", 'Ronda salvar com sucesso!')
        }
        setTimeout(() => {
            setRenderizarRonda(!retorno)
        }, 200)
    }

    const copiarPerguntas = (msg) => {
        const listaPerguntas = msg.data.listaPerguntas

        if (listaPerguntas.length > 0) {
            setListaPerguntas(listaPerguntas)
            setListaPerguntasModal(true)
        }
    }

    const handleSalvar = () => {
        if (!objEnviado.horario_inicial) {
            return showNotify("warning", `Inclua um horário inicial`)
        } else if (!objEnviado.horario_final) {
            return showNotify("warning", `Inclua um horário final`)
        } else if (!objEnviado.tempo_recorrencia) {
            return showNotify("warning", `Inclua um intervalo para recorrência`)
        } else if (objEnviado.entrada_escolhida.length == 0) {
            return showNotify("warning", `Escolha ao menos uma entrada`)
        } else if (objEnviado.perguntas.length === 0 || objEnviado.perguntas.every(pergunta => pergunta.trim() === '')) {
            return showNotify("warning", `Inclua ao menos uma pergunta`)
        }

        if (objEnviado.id) { // edicao
            addRoute("atualizarRonda", fecharEditRonda)
            sendWs("atualizarRonda", objEnviado)
        } else {
            addRoute("adicionaNovaRonda", fecharEditRonda)
            sendWs("adicionaNovaRonda", { objEnviado })
        }
    }

    const handleChangePergunta = ({ target }) => {
        const { id, value } = target
        setObjEnviado((prevState) => {
            const novasPerguntas = [...prevState.perguntas]
            novasPerguntas[id - 1] = value
            return {
                ...prevState,
                perguntas: novasPerguntas
            }
        })
    }

    const handleCopiarPerguntas = () => {
        sendWs("listaPerguntas", { idCentral })
        addRoute("listaPerguntas", copiarPerguntas)
    }

    const handleSalvarPerguntas = () => {
        setLinhas(checkedPerguntas.map((pergunta, index) => ({ id: index + 1 })))
        setListaPerguntasModal(false)
    }

    const handleCancelarClick = () => {
        // if (clickEditRonda == true) {
        //     sendWs("adicionaNovaRonda", { objEnviado })
        //     addRoute("adicionaNovaRonda", fecharEditRonda)
        // } else {
        // }
        setRenderizarRonda(false)
    }

    const getEntradasSelecionadas = () => {
        let ids_entradas_selecionadas = (rondaEdit && rondaEdit.entrada_monitorada ? rondaEdit.entrada_monitorada.split(',') : [])
        let selecionadas = listaEntrada.filter(e => {
            return ids_entradas_selecionadas.includes(`${e.id}`)
        })
        return selecionadas
    }

    return (
        <Grid sx={ContainerConfigRonda} >
            {openListaPerguntasModal &&
                <CopiarPerguntas
                    open={openListaPerguntasModal}
                    setOpen={setListaPerguntasModal}
                    title={'Perguntas feitas em rondas anteriores'}
                    listaPerguntas={listaPerguntas}
                    checkedPerguntas={checkedPerguntas}
                    setCheckedPerguntas={setCheckedPerguntas}
                    handleSalvarPerguntas={handleSalvarPerguntas}
                />
            }

            <Grid sx={GridPaiConfigRonda} >
                <Grid sx={GridConfigRonda}>
                    <Box sx={BoxAtivarRonda}>
                        <OneSwitch id='switch' checked={ativoEdit} onChange={(e) => atualizarSwitch(e.target.value)} />
                        <Typography sx={{ paddingLeft: '6%' }}>Ativar Ronda</Typography>
                    </Box>
                    <Box sx={BoxHorariosRonda}>
                        <Typography>Horário da Ronda: </Typography>
                        <Box style={{ width: '60px' }}>
                            <OneInput placeholder='--:--' id='horario1' type="text" value={horarioInicialEdit} onChange={(e) => atualizarHorario1(e.target.value)} maxLength="5"/>
                        </Box>
                        <Typography>Até</Typography>
                        <Box style={{ width: '60px' }}>
                            <OneInput placeholder='--:--' id='horario2' type="text" value={horarioFinalEdit} onChange={(e) => atualizarHorario2(e.target.value)} maxLength="5"/>
                        </Box>
                        <Typography sx={{ marginLeft: '10px' }}>Intervalo</Typography>
                        <Box style={{ width: '10%' }}>
                            <OneInput placeholder='000m' id='minutos' value={tempoRecorrenciaEdit} onChange={(e) => atualizarMinutos(e.target.value)}/>
                        </Box>
                        <Typography>minutos</Typography>
                    </Box>
                </Grid>
                <Grid sx={GridSelecionarEntradas}>
                    <Grid style={{ width: '30%' }} >
                        <Typography>Entradas:</Typography>
                    </Grid>
                    <Grid style={{ width: '70%' }} >
                        {
                            listaEntrada.length > 0 &&
                            <RondaSelect
                                defaultValue={getEntradasSelecionadas()}
                                name={"usuarios"}
                                label={"descricao"}
                                value={"id"}
                                options={listaEntrada}
                                setObjEnviado={setObjEnviado}
                                entradaMonitoradaEdit={entradaMonitoradaEdit}
                            />
                        }
                    </Grid>
                </Grid>
                <Grid sx={GridBtnsAddAndCopy}>
                    <Button variant="contained" color="one_primary" onClick={criarLinha}>ADICIONAR PERGUNTA</Button>
                    <Button variant="contained" color="one_primary" sx={{ visibility: 'hidden' }} onClick={handleCopiarPerguntas}>COPIAR PERGUNTAS</Button>
                </Grid>
                <Grid style={GridPerguntas}>
                    {checkedPerguntas.length > 0
                        ? (linhas.map((linha) => (
                            <Grid key={linha.id} sx={GridInputPergunta}>
                                <Typography sx={LegendaInputPergunta}>{linha.id}:</Typography>
                                <OneInput id={linha.id} onChange={handleChangePergunta} value={checkedPerguntas[linha.id - 1] || objEnviado.perguntas[linha.id - 1]} sx={InputPerguntas}/>
                                <Button sx={BtnDeletePergunta} onClick={() => removerLinha(linha.id)}><Delete /></Button>
                            </Grid>
                        )))
                        : (linhas.map((linha) => (
                            <Grid key={linha.id} sx={GridInputPergunta}>
                                <Typography sx={LegendaInputPergunta}>{linha.id}:</Typography>
                                <OneInput id={linha.id} onChange={handleChangePergunta} defaultValue={perguntasRondaEdit[linha.id - 1] || ''} value={objEnviado.perguntas[linha.id - 1] || ''} newSx={InputPerguntas} />
                                <Button sx={BtnDeletePergunta} onClick={() => removerLinha(linha.id)}><Delete /></Button>
                            </Grid>
                        )))
                    }
                </Grid>
            </Grid>
            <Grid sx={BtnsSalvarCancelar}>
                <Button variant="contained" color="one_primary" onClick={handleCancelarClick} type="button">Cancelar</Button>
                <Button variant="contained" color="one_primary" onClick={handleSalvar} type="button">Salvar</Button>
            </Grid>
        </Grid>
    )
}

export default RondaEdit
